import { fExecuteAPI } from "../../Server/Apis";
import {
  WMSStockTransfer_WMSStockTransferAttributes_GETROW,
  WMSStockTransfer_getStockEnquiry_GETROW,
} from "../../Server/ApiV2";
import { RoundingDigitRo, KernCAConfig } from "../../Redux/roStore";

import {
  fAlertToast,
  fcovertToNumber,
  fcheck_null_undefine_replace_empty,
  GetCostUpdate,
  Get_TransItemStockUOM,
} from "../../Utility/Utilitys";

import {
  Set_WmsStockTransfer_HeadObject_Set,
  Set_StockTransfer_HeadObject_A_VocNo,
  Wms_StockTransfer_HeadObject_Party_Set,
} from "./SliceWmsStockTransfer";

import { vRdxUserInfo, StockTransfer } from "../../Redux/roStore";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

export const ErrorMsg = {
  A_VocTyp: "",
  A_VocNo: "",
  A_PostDt: "",
  A_RefNo: "",
  A_RefDt: "",
  A_Type: "",
  A_PayMode: "",
  UnloadingBay: "",
  A_Party: "",
  A_PartyName: "",
  A_Curr: "",
  A_ExRate: "",
  A_Loc: "",

  TaxType: "",
  offer: "",
  A_RefBy: "",
  A_RefByname: "",
  A_CrAc: "",
  A_CrAcName: "",
  A_DrAc: "",
  A_DrAcName: "",
  A_Rounding: "",
  A_DocStat: "",
  A_Taxable: "",
  xErrorMsg: "",
  A_FromLoc: "",
  A_ToLoc: "",
  A_ToTrn: "",
  A_FromTrn: "",
  CreditLimit: "",
  OsAmount: "",
  AvlAmt: "",
  TransferType: "",
};
export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_Itmcd: "",
  B_ItmName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_BaseQty: "", //Decimal
  Reason: "",
};
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "WMINV10";

export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

export const locatonSearchData = ["Any", "Code", "Name"];

const sTax = [
  { Uid: "INTER-COMP-TSR", Name: "INTER-COMP-TSR" },
  { Uid: "OUTSIDE-TSR", Name: "OUTSIDE-TSR" },
  { Uid: "", Name: "" },
];

export const sTransferType = [{ Uid: "COST TO COST", Name: "COST TO COST" }];

export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];
//GCSearch

const GridDataColumnsLocationSearch = [
  { field: "id", headerName: "id", hide: true },
  { field: "UID", headerName: "Code" },
  { field: "Name1", headerName: "Name" },
];

const fKeyStockTransfer = (event) => {
  // WmsStockTransferContent
  const form = document.getElementById("WmsStockTransferHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fKeyStockTransferContent = (event) => {
  // WmsStockTransferContent
  const form = document.getElementById("WmsStockTransferContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fValidationHead_Client = (vRdxHead, setErrorMsg, sFooterObj) => {
  let iRes = true;

  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    fAlertToast("FAILED", "VocTyp should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    fAlertToast("FAILED", "VocNo should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PostDt === "" ||
    vRdxHead.A_PostDt === null ||
    vRdxHead.A_PostDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PostDt: "PostDt should not be empty",
    }));
    fAlertToast("FAILED", "PostDt should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Type === "" ||
    vRdxHead.A_Type === null ||
    vRdxHead.A_Type === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_Type: "Type should not be empty",
    }));
    fAlertToast("FAILED", "Type should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDt === "" ||
    vRdxHead.A_RefDt === null ||
    vRdxHead.A_RefDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDt: "Reference Date should not be Empty",
    }));
    fAlertToast("FAILED", "Reference Date should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_FromLoc === "" ||
    vRdxHead.A_FromLoc === null ||
    vRdxHead.A_FromLoc === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_FromLoc: "From Location should not be Empty",
    }));
    fAlertToast("FAILED", "From Location should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_ToLoc === "" ||
    vRdxHead.A_ToLoc === null ||
    vRdxHead.A_ToLoc === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_ToLoc: "To Location should not be Empty",
    }));
    fAlertToast("FAILED", "To Location should not be Empty");
    iRes = false;
  }

  if (vRdxHead.A_ToLoc === vRdxHead.A_FromLoc) {
    setErrorMsg((obj) => ({
      ...obj,
      A_ToLoc: "From Location and To Location should not be the same",
    }));
    fAlertToast(
      "FAILED",
      "From Location and To Location should not be the same"
    );
    iRes = false;
  }

  if (
    vRdxHead.A_Party === "" ||
    vRdxHead.A_Party === null ||
    vRdxHead.A_Party === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_Party: "Party should not be empty",
    }));
    fAlertToast("FAILED", "Party should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PartyName === "" ||
    vRdxHead.A_PartyName === null ||
    vRdxHead.A_PartyName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party Name should not be empty",
    }));
    fAlertToast("FAILED", "Party Name should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.TaxType === "" ||
    vRdxHead.TaxType === null ||
    vRdxHead.TaxType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TaxType: "Tax Type should not be Empty",
    }));
    fAlertToast("FAILED", "Tax Type should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.CreditLimit === "" ||
    vRdxHead.CreditLimit === null ||
    vRdxHead.CreditLimit === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      CreditLimit: "Credit Limit should not be Empty",
    }));
    fAlertToast("FAILED", "Credit Limit should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.OsAmount === "" ||
    vRdxHead.OsAmount === null ||
    vRdxHead.OsAmount === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      OsAmount: "Os Amount should not be Empty",
    }));
    fAlertToast("FAILED", "Os Amount should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.AvlAmt === "" ||
    vRdxHead.AvlAmt === null ||
    vRdxHead.AvlAmt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      AvlAmt: "Avl Amount should not be Empty",
    }));
    fAlertToast("FAILED", "Avl Amount should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.TransferType === "" ||
    vRdxHead.TransferType === null ||
    vRdxHead.TransferType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TransferType: "Transfer Type should not be Empty",
    }));
    fAlertToast("FAILED", "Transfer Type should not be Empty");
    iRes = false;
  }

  return iRes;
};

export const UnitRateFlag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj.WMINV03_UNITRATE_VLDT?.Val === "N";
  if (iShowField) {
    return false;
  } else {
    return true;
  }
};
const fValidationDetail_Client = (
  vRdxHead,
  sBufferObj,
  setErrorMsgDetail,
  sDetailGridData
) => {
  let iRes = true;

  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    fAlertToast("FAILED", "Serial number should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Type === "OUTLET TO DC" &&
    (sBufferObj.Reason === "" ||
      sBufferObj.Reason === null ||
      sBufferObj.Reason === undefined)
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      Reason: "Reason should not be empty",
    }));
    fAlertToast("FAILED", "Reason should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Itmcd === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    fAlertToast("FAILED", "Item code should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    fAlertToast("FAILED", "Item name should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Qty === "" || Number(sBufferObj.B_Qty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    fAlertToast("FAILED", "Qty should not be zero");
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    fAlertToast("FAILED", "Select unit");
    iRes = false;
  } else if (
    sBufferObj.B_PackQty === "" ||
    Number(sBufferObj.B_PackQty) === 0
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    fAlertToast("FAILED", "Pack quantity should not be zero");
    iRes = false;
  }

  return iRes;
};

//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(sItemSearch);
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", FinalObj);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.Type.response.data.message
        ? vItemSearch.Type.response.data.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

//API  UNIT_RATE_GETROW
const GetUnitRateArr = async (xItmCd, xUnitId, xType, xLoc) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    UnitId: xUnitId,
    Type: xType,
    Loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vUnitRateObj);

  const UnitRateInfo = await fExecuteAPI("WMINV10_UnitRate_GETROW", FinalObj);
  if (UnitRateInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitRateInfo.ResultSet.length > 0) {
      return UnitRateInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitRateInfo.Type.response.data.message
        ? UnitRateInfo.Type.response.data.message
        : "Error in UnitRateArr"
    );
    return [];
  }
};

//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
const fItemCodeDependency = async (
  vItemSearchFull,
  vRdxWmsHead,
  sBufferObj,
  setBufferObj,
  setUnit
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode, 
    }));

    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    let iUnit = vItemSearchFull[0]?.DefUnit || "";

    if (!iUnit) {
      iUnit = vItemSearchFull[0]?.PurUOM || "";
    }

    let vItemUnitSet = currentUnitArr.find((obj) => {
      return obj.Unit === iUnit;
    });

    if (!vItemUnitSet) {
      iUnit = currentUnitArr[0]?.Unit || "";

      vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });
    }

     await Unit_Onchange_001(              
             vItemUnitSet, 
            setBufferObj,
            sBufferObj
           );
         
    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

 export const Unit_Onchange_001 = async (    
    xUnitObj={}, 
    setBufferObj,
    sBufferObj
  ) => { 
    if (!!xUnitObj) {
      setBufferObj((obj) => ({
        ...obj,
        B_Unit: xUnitObj.Unit,
        B_UnitName: xUnitObj.Name1,
        B_PackQty: xUnitObj.PackQty,
      })); 
    }
  

    let { B_BaseQty } = fStockTransferCal(sBufferObj.B_Qty,  xUnitObj.PackQty);
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
    }));
  };

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch.Type == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

const fLoad_Grid = async (
  xB_VocNo,
  xB_Srno,
  setDetailGridData,
  setFooterObj,
  xVocTyp,
  xRoundingValue
) => {
  const iSIDetail = await GetSIDetail(xB_VocNo, xB_Srno, xVocTyp);
  if (iSIDetail.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
    var F_CrNetAmt = 0,
      F_CrTaxAmt = 0,
      F_RebateNetAmt = 0,
      F_RebateTaxAmt = 0,
      F_GrossAmt = 0,
      F_TaxAmt = 0;

    for (let i = 0; i < iSIDetail?.length; i++) {
      F_CrNetAmt += iSIDetail[i]?.B_CN_NeAmt;
      F_CrTaxAmt += iSIDetail[i]?.B_CN_Tax_Amt;
      F_RebateNetAmt += iSIDetail[i]?.B_Rbt_NeAmt;
      F_RebateTaxAmt += iSIDetail[i]?.B_Rbt_Tax_Amt;
      F_GrossAmt += iSIDetail[i]?.B_NetAmt;
      F_TaxAmt += iSIDetail[i]?.B_TaxAmt;
    }
    setFooterObj((obj) => ({
      ...obj,
      F_CrNetAmt: F_CrNetAmt.toFixed(xRoundingValue),
      F_CrTaxAmt: F_CrTaxAmt.toFixed(xRoundingValue),
      F_RebateNetAmt: F_RebateNetAmt.toFixed(xRoundingValue),
      F_RebateTaxAmt: F_RebateTaxAmt.toFixed(xRoundingValue),
      F_GrossAmt: F_GrossAmt.toFixed(xRoundingValue),
      F_TaxAmt: F_TaxAmt.toFixed(xRoundingValue),
      F_NetAmt: (F_TaxAmt + F_GrossAmt).toFixed(xRoundingValue),
    }));
  } else {
    setDetailGridData([]);
    setFooterObj((obj) => ({
      ...obj,
      F_CrNetAmt: (0).toFixed(xRoundingValue),
      F_CrTaxAmt: (0).toFixed(xRoundingValue),
      F_RebateNetAmt: (0).toFixed(xRoundingValue),
      F_RebateTaxAmt: (0).toFixed(xRoundingValue),
      F_GrossAmt: (0).toFixed(xRoundingValue),
      F_TaxAmt: (0).toFixed(xRoundingValue),
      F_NetAmt: (0).toFixed(xRoundingValue),
    }));
  }
};

//Reverse Modal
const fCloseReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(false);
};

const fOpenReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(true);
};

const fReverse = (fSave, setRevNarr, setReverseTransactionModal) => {
  fCloseReverseTransactionModal(setReverseTransactionModal);
  confirmAlert({
    title: "Reverse",
    message: "Are you sure to Reverse.",
    buttons: [
      {
        className: "alertBtn",
        label: "Yes",
        onClick: () => fSave(),
      },
      {
        className: "alertBtn",
        label: "No",
        onClick: () => setRevNarr(""),
      },
    ],
  });
};

//HEAD LOADING API
// Api

// Checkbox_Rights_GETROW
const GetCheckboxUserRights = async (dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const vCheckBoxRightsObj = {
    usercd: vRdxUserInfoObj.UserID,
    usergrp: vRdxUserInfoObj.UserGroupCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vCheckBoxRightsObj);
  const vCheckBoxRights = await fExecuteAPI(
    "Checkbox_User_Rights_GETROW",
    FinalObj
  );
  if (vCheckBoxRights?.Type?.toUpperCase() === "SUCCESS") {
    return vCheckBoxRights?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vCheckBoxRights?.response?.data?.message
        ? vCheckBoxRights?.response?.data?.message
        : "Error in CheckBoxRights"
    );
    return [];
  }
};

//SALESMAN_GETROW
const GetSalesman = async (dispatch) => {
  const iSalesman = await fExecuteAPI("SALESMAN_GETROW");
  if (iSalesman?.Type?.toUpperCase() === "SUCCESS") {
    return iSalesman.ResultSet.length > 0 ? iSalesman.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      iSalesman.response.data.Status
        ? iSalesman.response.data.Status
        : "Error in Currency"
    );
    return [];
  }
};

//API GRN_LOCATIONSEARCH_GETROW
const GetLocation = async (
  xAnyData,
  xCode,
  xName,
  UserID,
  setHeaderSearchResultArr,
  setHeaderSearchResultData
) => {
  let vHeaderSearchObj = {
    v_AnyData: xAnyData,
    v_Cd: xCode,
    v_Distri: "Y",
    v_Name: xName,
    v_UserCd: UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vHeaderSearchObj);

  const vHeaderSearch = await fExecuteAPI(
    "GRN_LOCATIONSEARCH_GETROW",
    FinalObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    setHeaderSearchResultData(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    ItemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("WMINV10_itemUnit_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.response.data.Status
        ? UnitInfo.response.data.Status
        : "Error in UnitArr"
    );
    return [];
  }
};

//API  ITEM_LINE_GETROW
const GetItemLineArr = async (xItemCode, xLoc, xParty, setItemLine) => {
  let vItemLineObj = {
    v_ItemCd: xItemCode,
    v_Loc: xLoc,
    v_Vendor: xParty,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemLineObj);

  const ItemLineInfo = await fExecuteAPI("ITEM_LINE_GETROW", FinalObj);
  if (ItemLineInfo.Status === 200) {
    if (ItemLineInfo.ResultSet.length > 0) {
      setItemLine(ItemLineInfo.ResultSet);
      return ItemLineInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      ItemLineInfo.Type.response.data.message
        ? ItemLineInfo.Type.response.data.message
        : "Error in ItemLineArr"
    );
    return [];
  }
};

//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xB_Srno, xVocTyp) => {
  let iSIDetailObj = {
    B_VocTyp: !!xVocTyp ? xVocTyp : "",
    B_VocNo: !!xB_VocNo ? xB_VocNo : "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await fExecuteAPI(
    "WMINV10_GridLoad_GETROW",
    FinalObj
  );
  if (iSIDetailResult?.Type?.toUpperCase() === "SUCCESS") {
    if (iSIDetailResult.ResultSet.length > 0) {
      return iSIDetailResult.ResultSet;
    } else {
      return [];
    }
  }
};

//API VALIDATIONDETAILINFO_GETROW
const fGetValidationDetailInfo_Server = async (
  sBufferObj,
  ErrorMsgDetail,
  setErrorMsgDetail
) => {
  const { HeadObject } = StockTransfer();
  let vResp = true;
  let vValidationDetailInfoObj = {
    vocTyp: HeadObject.A_VocTyp,
    vocNo: HeadObject.A_VocNo,
    B_Srno: sBufferObj.B_Srno,
    B_Itmcd: sBufferObj.B_Itmcd,
    A_Loc: HeadObject.A_FromLoc,
    B_Qty: sBufferObj.B_Qty,
    B_BaseQty: sBufferObj.B_BaseQty,
    type: HeadObject.A_Type,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vValidationDetailInfoObj);
  const vValidationDetailInfo = await fExecuteAPI(
    "WMINV10_validateDetail_GETROW",
    FinalObj
  );
  console.log(vValidationDetailInfo);
  if (vValidationDetailInfo.Type == "SUCCESS") {
    vResp = true;
  } else {
    if (vValidationDetailInfo.response.status == 400) {
      let isKeyAvailable =
        vValidationDetailInfo.response.data.ResultSet.field in ErrorMsgDetail;
      if (isKeyAvailable) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          [vValidationDetailInfo.response.data.ResultSet.field]:
            vValidationDetailInfo.response.data.Status,
        }));
      } else {
        if (vValidationDetailInfo.response.data.Status) {
          fAlertToast("FAILED", vValidationDetailInfo.response.data.Status);
        } else {
          fAlertToast("FAILED", "vValidationDetailInfo.response.data.Status");
        }
      }
      return (vResp = false);
    } else if (vValidationDetailInfo.response.status == 500) {
      // fAlertToast("FAILED", vValidationDetailInfo.response.Status);
      fAlertToast(
        "FAILED",
        vValidationDetailInfo?.response?.data?.message ||
          vValidationDetailInfo.response.data.Status
      );
      return (vResp = false);
    }
    return (vResp = false);
  }
  return vResp;
};

//API SaveSIHead
const fSaveHead = async (
  xSave,
  setUser_Doc_Arr,
  sUser_Doc_Arr,
  dispatch,
  fNewDetail,
  sBufferObj,
  xDocStatus = ""
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = StockTransfer();
  const iStatus = xSave ? HeadObject.A_DocStat : xDocStatus; //xSave False means Post
  let vSaveSIHeadObj = {
    A_VocTyp: HeadObject.A_VocTyp,
    A_VocNo: HeadObject?.A_VocNo,
    A_VocDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_RefDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
    A_RefNo: "",
    A_Party: "",
    A_Curr: "",
    A_ExRate: 1,
    A_PayMode: "",
    A_Type: "",
    A_Loc: HeadObject.A_FromLoc,
    A_RefBy: "",
    A_Narr: HeadObject.A_Narr,
    A_CrAc: "",
    A_DrAc: "",
    A_GrossAmt: 0,
    A_DiscPerc: "",
    A_DiscAmt: "",
    A_Rounding: "",
    A_DocStat: iStatus,
    IP: vRdxUserInfoObj.IP,
    UserId: vRdxUserInfoObj.UserID,
    A_Br: "",
    A_BrTo: "",
    A_LocTo: HeadObject.A_ToLoc,
    A_NetAmt: 0,
    A_RefNo1: "",
    A_RefNo2: "",
    A_RefNo3: "",
    A_RefNo4: 0,
    A_RefNo5: 0,
    A_RefNo6: 0,
    A_Typ: HeadObject.A_Type,
    A_Loc_TRN: HeadObject.A_FromTrn,
    A_LocTo_TRN: HeadObject.A_ToTrn,
    A_TRN_Type: HeadObject.TaxType,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await fExecuteAPI("WMINV10_saveHead_GETROW", FinalObj);
  if (vSaveSIHead?.Type?.toUpperCase() == "SUCCESS") {
    if (HeadObject?.A_VocNo == "0") {
      setUser_Doc_Arr([
        ...sUser_Doc_Arr,
        {
          A_VocTyp: HeadObject.A_VocTyp,
          A_VocNo: vSaveSIHead?.ResultSet[0]?.VocNo,
          SrNo: sUser_Doc_Arr.length + 1,
        },
      ]);
    }

    dispatch(
      Set_StockTransfer_HeadObject_A_VocNo({
        A_VocNo: xSave ? vSaveSIHead?.ResultSet[0]?.VocNo : HeadObject.A_VocNo,
        A_DocStat: iStatus,
      })
    );

    //approve bool type false
    if (!xSave) {
      fDisplay(
        HeadObject.A_VocTyp,
        xSave ? vSaveSIHead?.ResultSet[0]?.A_VocNo : HeadObject.A_VocNo,
        dispatch,
        fNewDetail
      );
      setTimeout(() => {
        GetCostUpdate(sTrnTyp, HeadObject?.A_VocTyp, HeadObject?.A_VocNo);
      }, 200);
      fAlertToast("SUCCESS", "Successfully posted");
    } else {
      fSaveDetail(vSaveSIHead.ResultSet[0].VocNo, sBufferObj, fNewDetail);
    }
  } else {
    fAlertToast(
      "FAILED",
      !!vSaveSIHead.response.data.message
        ? vSaveSIHead?.response?.data?.message
        : "Fail to Save Head"
    );
  }
};

//API GETSIHEAD_GETROW to gethead
const fDisplay = async (xA_VocTyp, A_VocNo, dispatch, fNewDetail) => {
  const { HeadObject } = StockTransfer();
  let vSIHeadObj = {
    VocTyp: xA_VocTyp,
    VocNo: A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
  const vSIHead = await fExecuteAPI("WMINV10_fDisplay_GETROW", FinalObj);

  if (vSIHead?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_WmsStockTransfer_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: vSIHead.ResultSet[0].A_VocTyp,
        A_VocTypName: vSIHead.ResultSet[0].VocName,
        A_VocNo: vSIHead.ResultSet[0].A_VocNo,
        A_PostDt: vSIHead.ResultSet[0].A_PostDt,
        A_RefDt: vSIHead.ResultSet[0].A_RefDt,
        A_Party: vSIHead.ResultSet[0].A_Party,
        A_PartyName: vSIHead.ResultSet[0].PartyName,
        A_Type: vSIHead.ResultSet[0].A_TYP,
        A_FromLoc: vSIHead.ResultSet[0].A_Loc,
        A_FromLocName: vSIHead.ResultSet[0].LocName,
        A_ToLoc: vSIHead.ResultSet[0].A_LocTo,
        A_ToLocName: vSIHead.ResultSet[0].LocNameTo,
        A_Narr: vSIHead.ResultSet[0].A_Narr,
        A_DocStat: vSIHead.ResultSet[0].A_DocStat,
        A_FromTrn: vSIHead.ResultSet[0].A_Loc_TRN,
        A_ToTrn: vSIHead.ResultSet[0].A_LocTo_TRN,
        TaxType: vSIHead.ResultSet[0].A_TRN_Type,
      })
    );
    fLocationDependency(vSIHead.ResultSet[0].A_LocTo, dispatch);

    fNewDetail(vSIHead.ResultSet[0].A_VocNo, vSIHead.ResultSet[0].A_VocTyp);
  }
};

//API SAVESIDETAIL_GETROW
const fSaveDetail = async (xB_VocNo, sBufferObj, fNewDetail) => {
  const { HeadObject } = StockTransfer();

  let vSaveSIDetailObj = {
    B_VocTyp: HeadObject?.A_VocTyp,
    B_VocNo: xB_VocNo,
    B_Srno: Number(sBufferObj.B_Srno),
    B_Itmcd: sBufferObj.B_Itmcd,
    B_Qty: sBufferObj.B_Qty,
    B_Unit: sBufferObj.B_Unit,
    B_BaseQty: sBufferObj.B_BaseQty,
    B_UCost: 0,
    B_NetAmt: 0,
    B_RSP: 0,
    B_RefNo1: "",
    B_RefNo2: "",
    B_RefNo3: "",
    B_RefNo4: 0,
    B_RefNo5: 0,
    B_RefNo6: 0,
    B_TaxDept: "",
    B_TaxPerc: 0,
    B_TaxAmt: 0,
    B_Charges9: 0,
    B_TotCharges9: 0,
    B_AvgVal: 0, //by sir
    B_CN_Amt: 0,
    B_CN_NeAmt: 0,
    B_CN_Tax_Perc: 0,
    B_CN_Tax_Amt: 0,
    B_Rbt_Amt: 0,
    B_Rbt_NeAmt: 0,
    B_Rbt_Tax_Perc: 0,
    B_Rbt_Tax_Amt: 0,
    B_Res1_Amt: 0,
    B_Res1_NetAmt: 0,
    B_Res2_Amt: 0,
    B_Res2_NetAmt: 0,
    B_Res3_Amt: 0,
    B_Res3_NetAmt: 0,
    B_Res4_Amt: 0,
    B_Res4_NetAmt: 0,
    B_Res5_Amt: 0,
    B_Res5_NetAmt: 0,
    B_Charges10: 0,
    B_TotCharges10: 0,
    B_Reason: sBufferObj.Reason,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIDetailObj);
  const vSaveSIDetail = await fExecuteAPI(
    "WMINV10_saveDetail_GETROW",
    FinalObj
  );
  if (vSaveSIDetail?.Type?.toUpperCase() === "SUCCESS") {
    fNewDetail(xB_VocNo, HeadObject?.A_VocTyp);
    fAlertToast("SUCCESS", "Successfully Saved");
  } else {
    fAlertToast(
      "FAILED",
      !!vSaveSIDetail.response.data.message
        ? vSaveSIDetail?.response?.data?.message
        : "Fail to Save Detail"
    );
  }
};

const Get_ToggleDropDown_Load = async (
  xData,
  xType,
  xAcTyp,
  xExact,
  dispatch
) => {
  const { HeadObject } = StockTransfer();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_FromLoc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    FinalObj
  );
  if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

//API VALIDATE_HEAD_WMINV03_APPROVE_GETROW
const GetValidateHead_Server = async (dispatch, xApprove) => {
  const { HeadObject } = StockTransfer();
  const vRdxUserInfoObj = vRdxUserInfo();

  let vValidateHeadApproveObj = {
    xTrnTyp: sTrnTyp,
    xVocTyp: HeadObject.A_VocTyp,
    xVocNo: HeadObject.A_VocNo,
    xPostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    xLoc: HeadObject.A_FromLoc,
    xLocTo: HeadObject.A_ToLoc,
    xParty: HeadObject.A_Party,
    xUserCd: vRdxUserInfoObj?.UserID,
    xUserGrp: vRdxUserInfoObj?.UserGroupCode,
    xApprove: xApprove,
    xTyp: HeadObject.A_Type,
    xTaxType: HeadObject.TaxType,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vValidateHeadApproveObj);
  const vValidateHeadApprove = await fExecuteAPI(
    "WMINV10_validateHead_GETROW",
    FinalObj
  );
  if (vValidateHeadApprove?.Type?.toUpperCase() === "SUCCESS") {
    return true;
  } else if (vValidateHeadApprove.Type === "FAILED") {
    fAlertToast(
      "FAILED",
      !!vValidateHeadApprove.Status
        ? vValidateHeadApprove.Status
        : "Error Validate Head Approve"
    );
    return false;
  } else {
    fAlertToast("FAILED", vValidateHeadApprove.response.data.Status);

    return false;
  }
};

//API SALESGROUP
const GetSalesGroups = async (xA_Loc) => {
  const vSalesGroups = await fExecuteAPI("SALESGROUPS_GETROW", xA_Loc);
  if (vSalesGroups.Type == "SUCCESS") {
    return vSalesGroups.ResultSet;
  } else {
    fAlertToast("FAILED", vSalesGroups.Message);
    return [];
  }
};

var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const GetHeadLocation = async (dispatch, setFromLocation, setToLocation) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = StockTransfer();
  const vLocationObj = {
    // GroupId: vRdxUserInfoObj.UserGroupCode,
    UserCd: vRdxUserInfoObj.UserID,
    type: HeadObject.A_Type,
  };
  const vLocation = await fExecuteAPI("WMINV10_Location_GETROW", vLocationObj);
  if (vLocation?.Type?.toUpperCase() === "SUCCESS") {
    setFromLocation(vLocation?.ResultSet?.LocFrom);
    setToLocation(vLocation?.ResultSet?.LocTo);
    return vLocation?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vLocation.response.data.message
        ? vLocation.response.data.message
        : "Error in Location"
    );
    return [];
  }
};
const GetParty = async (dispatch, xLoc) => {
  const vPartyObj = {
    Loc: xLoc,
  };
  const vParty = await fExecuteAPI("WMINV10_Party_GETROW", vPartyObj);
  if (vParty?.Type?.toUpperCase() === "SUCCESS") {
    return vParty?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vParty.response.data.message
        ? vParty.response.data.message
        : "Error in Party"
    );
    return [];
  }
};
const fLocationDependency = async (Locparty, dispatch) => {
  let iParty = {
    AcCd: "",
    Name2: "",
    OSAmt: 0,
    PDCAmt: "",
    CrLimit: 0,
    Blocked: "",
  };

  let vParty = await GetParty(dispatch, Locparty);
  if (vParty.length > 0) {
    iParty = vParty[0];
  }
  dispatch(
    Wms_StockTransfer_HeadObject_Party_Set({
      A_Party: iParty.AcCd,
      A_PartyName: iParty.Name2,
      CreditLimit: iParty.CrLimit,
      OsAmount: iParty.OSAmt,
      AvlAmt: Number(iParty?.CrLimit) - Number(iParty?.OSAmt),
    })
  );
};

//calculation
const fStockTransferCal = (xQty, xPackQty) => {
  const { roundingDigit } = RoundingDigitRo();
  const B_Qty = fcovertToNumber(xQty);
  const B_PackQty = fcovertToNumber(xPackQty);

  let B_BaseQty = B_PackQty * B_Qty;

  return {
    B_BaseQty: B_BaseQty.toFixed(roundingDigit), //Decimal
  };
};

//API "GetItemAttributesPurchase_GETROW"
const GetItemAttributesPurchase = async (dispatch, sBufferObj) => {
  const { HeadObject } = StockTransfer();
  let vItemAttributesPurchaseObj = {
    itmCd: sBufferObj.B_Itmcd,
    loc: HeadObject.A_FromLoc,
    locto: HeadObject.A_ToLoc,
    taxType: HeadObject.TaxType,
    TaxDept1: sBufferObj?.B_TaxDept,
    TaxDept2: sBufferObj?.B_TaxDept2,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemAttributesPurchaseObj);
  const vItemAttributesPurchase = await fExecuteAPI(
    "WMINV10_getItemAttributesPurchaseReturn_GETROW",
    FinalObj
  );
  if (vItemAttributesPurchase?.Type?.toUpperCase() === "SUCCESS") {
    return vItemAttributesPurchase.ResultSet;
  } else {
    fAlertToast("FAILED", vItemAttributesPurchase?.response?.data?.Status);
    return [];
  }
};
//API VALIDATE_COST_VARIANCE_GETROW
const GetValidateCostVariance = async (dispatch) => {
  const { HeadObject } = StockTransfer();
  const vRdxUserInfoObj = vRdxUserInfo();

  let vValidateCostVarianceObj = {
    voctyp: HeadObject?.A_VocTyp,
    vocno: HeadObject?.A_VocNo,
    usercd: vRdxUserInfoObj?.UserID,
  };
  const vValidateCostVariance = await fExecuteAPI(
    "WMINV10_validatecostvariance_GETROW",
    vValidateCostVarianceObj
  );
  if (vValidateCostVariance.Type?.toUpperCase() === "SUCCESS") {
    return vValidateCostVariance.ResultSet.length > 0
      ? vValidateCostVariance.ResultSet
      : [];
  } else if (vValidateCostVariance.response.status == 400) {
    fAlertToast("FAILED", vValidateCostVariance.response.data.Status);
    return [];
  } else if (vValidateCostVariance.response.status == 500) {
    fAlertToast("FAILED", vValidateCostVariance.response.data.Status);
    return [];
  }
};
export const GetAttributes = async (
  setObjectRights,
  setUser_Doc_Arr,
  setLocationArr,
  setDocLoading,
  setReason
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await WMSStockTransfer_WMSStockTransferAttributes_GETROW(
    vObj
  );
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setLocationArr(iAttributes?.data?.ResultSet?.LoactionSearch);
    setReason(iAttributes?.data?.ResultSet?.Reason);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const GetHeadGrid = async (
  setHeadGridRow,
  setHeadGridShow,
  itemcode = ""
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = StockTransfer();
  var vObj = {
    itmCd: itemcode,
    userCd: vRdxUserInfoObj.UserID,
    loc: HeadObject.A_FromLoc,
  };
  const iAttributes = await WMSStockTransfer_getStockEnquiry_GETROW(vObj);
  if (iAttributes?.status === 200 && iAttributes?.data?.ResultSet.length > 0) {
    setHeadGridRow(iAttributes?.data?.ResultSet);
    setHeadGridShow(true);
  } else {
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};

export {
  fRightClick,
  fLeftClick,
  sTax,
  fKeyStockTransfer,
  fKeyStockTransferContent,
  GridDataColumnsLocationSearch,
  // Api
  GetCheckboxUserRights,
  GetSalesman,
  GetLocation,
  GetUnitArr,
  GetItemLineArr,
  GetItemFullSearchArr,
  GetItemSearch,
  fItemCodeDependency,
  GetSearchItem,
  GetSalesGroups,
  GetUnitRateArr,
  //save
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fSaveHead,
  fSaveDetail,
  fDisplay,

  //reverse
  fCloseReverseTransactionModal,
  fOpenReverseTransactionModal,
  fReverse,
  //Head functions
  GetHeadLocation,
  fLocationDependency,
  GetParty,

  //src doc
  Get_ToggleDropDown_Load,
  fStockTransferCal,

  //Validation
  GetItemAttributesPurchase,
  fGetValidationDetailInfo_Server,
  //Approve
  GetValidateHead_Server,
  GetValidateCostVariance,
};
